// extracted by mini-css-extract-plugin
module.exports =  {"container":"_33974c2b58--container--IorYh","icon":"_33974c2b58--icon--fn4aO","name":"_33974c2b58--name--CxhuH"};